import { CreditReport } from '../types';

export const mockCreditReport: CreditReport = {
  creditors: [
    {
      name: "Chase",
      balance: 15000,
      creditLimit: 16000,
      utilization: 93.75,
      monthlyPayment: 450,
      interestRate: 24.99
    },
    {
      name: "Capital One",
      balance: 8500,
      creditLimit: 10000,
      utilization: 85.0,
      monthlyPayment: 255,
      interestRate: 22.99
    },
    {
      name: "Bank of America",
      balance: 12000,
      creditLimit: 15000,
      utilization: 80.0,
      monthlyPayment: 360,
      interestRate: 21.99
    },
    {
      name: "Discover",
      balance: 6500,
      creditLimit: 10000,
      utilization: 65.0,
      monthlyPayment: 195,
      interestRate: 19.99
    }
  ],
  totalBalance: 42000,
  totalCreditLimit: 51000,
  totalMonthlyPayment: 1260,
  creditUtilization: 82.35
};
